import type { Subtitle, SubtitlesPositions, SubtitlesSize } from '../../../components/subtitles/types';
import { useCoreSelector } from '../../CoreStore';

import { SubtitlesDefaultLang, SubtitlesGroup } from './types';

export const useSubtitlesSlice = {
  group: (): SubtitlesGroup => {
    return useCoreSelector(({ subtitles }) => subtitles.group);
  },
  isEnabled: (): boolean => {
    return useCoreSelector(({ subtitles }) => subtitles.isEnabled);
  },
  isOnboarded: (): boolean => {
    return useCoreSelector(({ subtitles }) => subtitles.isOnboarded);
  },
  isAvailable: (): boolean => {
    return useCoreSelector(({ subtitles }) => subtitles.isAvailable);
  },
  positions: (): SubtitlesPositions | null => {
    return useCoreSelector(({ config, subtitles }) => {
      const gameType = config.session?.gametype;
      return (gameType && subtitles.positionsRaw?.[gameType]) || null;
    });
  },
  sizes: (): SubtitlesSize => {
    return useCoreSelector(({ subtitles }) => subtitles.sizes);
  },
  subtitle: (): Subtitle => {
    return useCoreSelector(({ subtitles }) => subtitles.subtitle);
  },
  lang: (lang: string): string => {
    return useCoreSelector(({ subtitles }) =>
      subtitles.group === SubtitlesGroup.GROUP3 ? SubtitlesDefaultLang : lang
    );
  },
};
